import get from '~/helpers/get'

export default ({ app, store }, inject) => {
  const gtm = {
    id: app.$env.GTM_ID,
    activated: false,
    activate: () => {
      if (!process.browser) return

      const { currentUser } = store.getters
      const hasAcceptedAnalytics = get(currentUser, 'account.analyticsConsent', app.$cookies.get('cookie_consent'))

      if (!app.$gtm.activated && app.$gtm.id && hasAcceptedAnalytics) {
      // Build the header script
        const headerScript = document.createElement('script')
        headerScript.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${app.$gtm.id}');`

        // Build the body script
        const bodyScript = document.createElement('noscript')
        const bodyFrame = document.createElement('iframe')
        const bodyAttributes = {
          src: `https://www.googletagmanager.com/ns.html?id=${app.$gtm.id}`,
          height: 0,
          width: 0,
          style: 'display:none;visibility:hidden'
        }

        Object.entries(bodyAttributes).forEach(([attr, value]) => {
          bodyFrame.setAttribute(attr, value)
        })

        bodyScript.appendChild(bodyFrame)

        // Attach to document
        const body = document.getElementsByTagName('body')[0]
        const firstElement = body.childNodes[0]
        body.insertBefore(bodyScript, firstElement)

        const head = document.getElementsByTagName('head')[0]
        head.appendChild(headerScript)

        if (window && window.dataLayer) {
          const userID = get(currentUser, 'account.id', 'anonymous')
          window.dataLayer.push({ userID })
        }

        app.$gtm.activated = true
      }
    }
  }

  store.watch(
    state => state.cookie_consent.consent,
    () => gtm.activate()
  )

  inject('gtm', gtm)
}
